import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrAccordion } from './tr-accordion.component';
import { TrAccordionTab } from './tr-accordion-tab.component';
import { TrAccordionContent } from './tr-accondion-content.component';
import { TrAccordionHeader } from './tr-accondion-header.component';

@NgModule({
  imports: [CommonModule],
  exports: [TrAccordion, TrAccordionTab, TrAccordionHeader, TrAccordionContent],
  declarations: [TrAccordion, TrAccordionTab, TrAccordionHeader, TrAccordionContent],
})
export class TrAccordionModule { }
